// extracted by mini-css-extract-plugin
export default {"favorite-label-wrapper":"zNaVH_favorite-label-wrapper","bottom-label-full-width-text":"msj_R_bottom-label-full-width-text"};